module.exports = __webpack_public_path__ + "img/rayoga.f34ad64c.svg";